import { useNavigate } from "react-router-dom";
import Table from "../../../Components/Tables/Table";
import PageHeader from "../../../Layout/PageHeader";
import { usePagination } from "../../../hooks/usePagination";
import { useEffect, useState } from "react";
import { ApiResponse } from "../../../model/common/apiResponse";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import { toast, Toaster } from 'react-hot-toast';
import Pagination from "../../../Shared/Pagination/Pagination";
import Card from "../../../Shared/Cards/Card";
import { SetupListProps } from "../model/setup.model";
import { changeStatus, fetchList } from "../service/setup.service";
import CardImage from "../../../Shared/Cards/CardImage";
import { formatSearchDate, isValidDate } from "../../../Utility/Utility";



const SetupList: React.FC<SetupListProps> = ({
    pageName,
    columns,
    addUrl,
    listUrl,
    gridUrl,
    viewtype,
    headers,
    getDetails,
    search_columns,
    db_columns,
    update_status_url,
    statusData,
    setStatusData,
    onDataChange,
    data: parentData,
    refreshTrigger = 0,
    handelEditAction,
    listEndpoint,
    sorting_order,
    userAccess,
    cardType=""
}) => {
    const navigation = useNavigate();
    const { currentPage, handlePageChange, perPage } = usePagination();
    const [data, setData] = useState<ApiResponse<any> | null>(parentData || null);
    const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
    useSearchStore();

    const [loading,setLoading] = useState<boolean>(false);
    useEffect(() => {
         setData(null);
        resetSearch();
      }, [ resetSearch,viewtype]);
      useEffect(() => {
        setData(null);
        if (searchTerm != previousSearchTerm && currentPage != 1) {
          handlePageChange(1);
        }
    
        let order: any[] = [];
        const formattedSearch = isValidDate(searchTerm) ? formatSearchDate(searchTerm) : searchTerm;

        const payload: any = {
          columns: db_columns,
          limit: perPage,
          page: currentPage,
          search: formattedSearch,
          order: sorting_order,
        };
        if (order.length > 0) {
          Object.assign(payload, { order });
        }
        console.log(search_columns,"search_columns");
        if (search_columns.length > 0) {
          Object.assign(payload, { search_columns });
        }
           
            fetchList(listEndpoint,payload).then((response:any) => {
                setData(response?? null);
                setPreviousTerm(searchTerm);
                if (onDataChange) {
                    onDataChange(response);
                }
            });
      }, [currentPage, searchTerm,viewtype,statusData,refreshTrigger]);



    const handleToggleChange= (item:any,status: any)=>{
        resetSearch();
        setLoading(true);
        const payload= {
        "is_active": status
        }
         changeStatus(`${update_status_url}/${item.id}`,payload).then((response:ApiResponse<any>) => {
              
              if(response.status==200){
                if(setStatusData){
                    setStatusData(response.data);
                }
                toast.success(`${pageName.slice(0,-1)} status updated Successfully!`, {
                    duration: 5000,
                  });
                setLoading(false);
              }else{
                toast.error(`Failed to update ${pageName.slice(0,-1)} status!`, {
                    duration: 5000,
                  });
                setLoading(false);
              }
              setLoading(false);
  
         })
    }
    return (
        <>
            {loading && <Loader />}
            {data ? (
                <>
                    <Toaster />
                    <PageHeader
                        addUrl={addUrl}
                        listUrl={listUrl}
                        gridUrl={gridUrl}
                        name={pageName}
                        hideAddButton={userAccess && !userAccess?.is_spherewms_admin ? true : false}
                    />
                    <div className="clearfix"></div>
                    {
                        viewtype === 'grid-view' ? (
                            <div className="grid-view h-100">
                                <h5 className="text-start">{pageName}</h5>
                                <div className="d-flex align-content-start flex-wrap h-100">
                                    {
                                    cardType ==='image'?  <CardImage
                                    fields={columns}
                                    data={data?.data?.results || []}
                                    header={headers}
                                    getDetails={getDetails}
                                    handleToggleChange={handleToggleChange}
                                    />:
                                    <Card fields={columns} data={data?.data?.results || []} header={headers} getDetails={getDetails}  handleToggleChange={handleToggleChange} handleEditAction={handelEditAction}
                                    hideEditButton={userAccess && !userAccess?.is_spherewms_admin ? true : false}
                                    />
                                    }
                                    {data?.data?.results?.length === 0 && (
                                        <div className="no-record-found-div w-100 h-100 d-flex justify-content-center align-items-center fs-5 text-grey">
                                            No records found
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <Pagination
                                      totalRecords={data?.data?.recordsTotal}
                                      recordsPerPage={perPage}
                                      currentPageState={[currentPage, handlePageChange]}
                                    />
                                
                                </div>
                            </div>
                        ) : (
                            <>
                                <h5 className="text-start">{pageName}</h5>
                                <div className="customerTableMainDiv">
                                    <Table columns={columns} data={data?.data?.results || []} 
                                    pagination={{
                                        recordsPerPage: perPage,
                                        totalRecords: data?.data?.recordsTotal,
                                        currentPage: currentPage,
                                        onCurrentPageChange: handlePageChange,
                                      }}
                                      CheckboxStatus={false}
                                    />
                                </div>
                            </>
                        )
                    }
                </>
            ) : <Loader />}
        </>
    );
}
export default SetupList;